export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";